import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Home } from "./pages/Home";
import { Cases } from "./pages/Cases";
type AppProps = {
  showReviewNotes?: boolean;
  eventsState?: "upcoming" | "empty";
};
function PagePosition() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    requestAnimationFrame(() => {
      if (hash) {
        const target = document.getElementById(decodeURIComponent(hash.slice(1)));
        target?.scrollIntoView({
          behavior: "auto",
          block: "start"
        });
        if (target?.hasAttribute("tabindex")) target.focus({
          preventScroll: true
        });
      } else window.scrollTo(0, 0);
    });
  }, [pathname, hash]);
  return null;
}
export function App({
  showReviewNotes = true,
  eventsState = "upcoming"
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="28sl3gxardmez">
      <PagePosition data-id="element-1" data-mp="28s2zfehuu3wi" />
      <Routes data-id="element-2" data-mp="23vkzqt1dsvr1">
        <Route path="/cases/*" element={<Cases data-id="element-4" data-mp="23ut97wmn5o7m" />} data-id="element-3" data-mp="23w4ey1znd61d" />
        <Route path="*" element={<Home showReviewNotes={showReviewNotes} showEmptyEvents={eventsState === "empty"} data-id="element-6" data-mp="3ik7ekc2063oj" />} data-id="element-5" data-mp="23ti8k5ohswkq" />
      </Routes>
    </BrowserRouter>;
}